import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { SwitchSubPortfolioForm } from './SwitchSubPortfolioForm'

export function SwitchSubPortfolioCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.unitlink.useSwitchSubPortfolioActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.SwitchSubPortfolioCommandData"
      title={translate('switchSubPortfolioModalButton.title')}
      commandDataForm={SwitchSubPortfolioForm}
      {...props}
      submit={submit}
    />
  )
}
